import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: () => import("../components/home/Home.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/AddUser",
    name: "AddUser",
    component: () => import("../components/AddUser.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/UserPermission",
    name: "UserPermission",
    component: () => import("../components/scan/userinfo/UserPermission.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/UserCreation",
    name: "UserCreation",
    component: () => import("../components/scan/userinfo/UserCreation.vue"),
    meta: { requiresAuth: false },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
